import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMTag } from 'src/app/models/crm/crmtag';

@Injectable({
  providedIn: 'root'
})
export class CrmtagService {

  constructor(private http: HttpClient) { }

  consultarTags() {
    return this.http.get<CRMTag[]>(globals.apiUrl + '/api/CRMTag/Lista');
  }

  consultarTagComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, statusCadastro) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (statusCadastro !== null) {
      parametros = parametros.set('statusCadastro', statusCadastro);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMTag/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdTag(idTag) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMTag/Buscar',
      { params: new HttpParams().set('id', idTag) });
  }

  salvar(tag: CRMTag) {
    return this.http.post(globals.apiUrl + '/api/CRMTag/Salvar', tag);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMTag/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}